const fieldList = {
    identifier: {
        icon: '/AvatarFields/idIcon.png',
        type: 'text',
        readOnly: true,
        placeholder: 'Identifiant utilisateur',
    },
    firstname: {
        icon: '/AvatarFields/userIcon.png',
        type: 'text',
        placeholder: 'Prénom',
        maxLength: 50,
        minLength: null,
    },
    name: {
        icon: '/AvatarFields/userIcon.png',
        type: 'text',
        placeholder: 'Nom',
        maxLength: 50,
        minLength: null,
    },
    email: {
        icon: '/AvatarFields/mailIcon.png',
        type: 'email',
        placeholder: 'Email',
        maxLength : 320,
        minLength : null,
    },
    phone: {
        icon: '/AvatarFields/numberIcon.png',
        type: 'tel',
        placeholder: 'Téléphone',
        maxLength: 20,
        minLength: null,
    },
    traderCode: {
        icon: '/AvatarFields/keyIcon.png',
        type: 'text',
        placeholder: 'Code commerçant',
        maxLength : 4,
        minLength : 4,
    },
    address: {
        icon: '/AvatarFields/addressIcon.png',
        type: 'text',
        placeholder: 'Adresse',
        maxLength: 100,
    },
    link: {
        icon: '/AvatarFields/linkIcon.png',
        type: 'text',
        placeholder: 'Site Web',
        maxLength: 1024,
    },
    insta: {
        icon: '/AvatarFields/instaIcon.png',
        type: 'text',
        placeholder: 'Instagram',
        maxLength: 1024,
    },
    tiktok: {
        icon: '/AvatarFields/tiktokIcon.png',
        type: 'text',
        placeholder: 'Tiktok',
        maxLength: 1024,
    },
    facebook: {
        icon: '/AvatarFields/facebookIcon.png',
        type: 'text',
        placeholder: 'Facebook',
        maxLength: 1024,
    },
};

export default fieldList;